import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/back.svg';
const BackArrow = (props: any): ReactElement => {
  return <img src={icon} {...props} />;
};
export default BackArrow;
